import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Button } from '@carvana/core-helios-button';
import ContactIcon from '../../../../assets/contact.svg';
import styles from './coverage.module.css';

export const ContactUs = () => {
  return (
    <div className={styles['coverage']}>
      <div className={styles['coverage-contact']}>
        <img src={ContactIcon} alt="Contact an Advocate" />
        <div>Contact an Advocate</div>
        <p>One of our Advocates may be able to resolve your issue.</p>
        <Button
          onClick={() => {
            window.open('https://www.carvana.com/help/?open-contact-window=true', '_blank');

            datadogRum.addAction(AnalyticEvents.sarCoverageScreenClickedBottomButton, {
              type: 'contact-us',
            });
          }}
        >
          Contact us
        </Button>
      </div>
    </div>
  );
};
